<template>
    <!--<div class="md-layout-item md-small-size-100 md-medium-size-50 md-size-50">-->
    <div class="md-layout-item md-medium-size-100 md-xlarge-size-75">
        <h3>Core Details</h3>
        <p class="margin_bottom">Core details for the building/website</p>

        <div class="md-layout md-gutter">
            <label class="md-layout-item md-size-25 md-form-label">
                Portfolio
            </label>
            <div class="md-layout-item">
                <md-field>
                    <md-input disabled title="Not editable" v-model="details.portfolio" type="text"></md-input>
                </md-field>
            </div>
        </div>

        <div class="md-layout md-gutter">
            <label class="md-layout-item md-size-25 md-form-label">
                Name
            </label>
            <div class="md-layout-item md-size-50">
                <ValidationProvider name="Name" rules="required|min:5|max:100" v-slot="{ passed, failed }">
                    <md-field :class="[ { 'md-error': failed },{ 'md-valid': passed } ]">
                        <md-input v-model="details.name" type="text" autocomplete="new-name" placeholder="Building Name"></md-input>
                        <span class="md-helper-text">For website (5-100 characters, use address if no name)</span>
                        <slide-y-down-transition><md-icon class="error" v-show="failed">close</md-icon></slide-y-down-transition>
                        <slide-y-down-transition><md-icon class="success" v-show="passed">done</md-icon></slide-y-down-transition>
                    </md-field>
                </ValidationProvider>
            </div>
        </div>

        <div class="md-layout md-gutter">
            <label class="md-layout-item md-size-25 md-form-label">
                Website Description
            </label>
            <div class="md-layout-item">
                <ValidationProvider name="Website Description" rules="required|min:15|max:200" v-slot="{ passed, failed }">
                    <md-field :class="[ { 'md-error': failed },{ 'md-valid': passed } ]">
                        <md-textarea v-model="details.description" md-autogrow></md-textarea>
                        <span class="md-helper-text">e.g. "Period office building in central location with excellent transport links" (15-200 characters)</span>
                        <slide-y-down-transition><md-icon class="error" v-show="failed">close</md-icon></slide-y-down-transition>
                        <slide-y-down-transition><md-icon class="success" v-show="passed">done</md-icon></slide-y-down-transition>
                    </md-field>
                </ValidationProvider>
            </div>
        </div>

        <div class="md-layout md-gutter">
            <label class="md-layout-item md-size-25 md-form-label">
                sqft
            </label>
            <div class="md-layout-item md-size-60">
                <div id="div_sqft">
                    <ValidationProvider name="Sqaure Feet" rules="required|min_value:50|max_value:2147483647" v-slot="{ passed, failed }">
                        <md-field class="val-inset" :class="[ { 'md-error': failed },{ 'md-valid': passed } ]">
                            <span class="md-prefix">ft&sup2;</span>
                            <md-input type="number" v-model="details.sqft" min="50" step="100" max="2147483647"></md-input>
                            <span class="md-helper-text">Total square footage of building</span>

                            <slide-y-down-transition><md-icon class="error" v-show="failed">close</md-icon></slide-y-down-transition>
                            <slide-y-down-transition><md-icon class="success" v-show="passed">done</md-icon></slide-y-down-transition>
                        </md-field>
                    </ValidationProvider>

                    <div id="div_sqm">
                        <span class="custom-prefix" v-if="details.sqft != null">m&sup2;</span>
                        <span>{{sqm}}</span>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
    import { SlideYDownTransition } from "vue2-transitions";
    import { extend } from "vee-validate";
    import { required, email, min, max, min_value, max_value } from "vee-validate/dist/rules";
    extend("email", email);
    extend("required", required);
    extend("min", min);
    extend("max", max);
    extend("min_value", min_value);
    extend("max_value", max_value);

    import Help from "@/ts/Help";

    export default {
        name: "BuildingDetails",
        components: {
            SlideYDownTransition
        },
        props: {
            details: {
                portfolio: null,
                portfolioId: null,
                name: null,
                description: null,
                sqft: null
            }
        },
        computed: {
            sqm() {
                return Help.sqftTosqm(this.details.sqft);
            }
        }
    }</script>
<style lang="scss">

    #div_sqft {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .md-field

    {
        width: 200px;
    }

    }

    #div_sqm {
        width: 200px;
        margin-left: 40px;
    }

    .custom-prefix {
        color: rgba(0, 0, 0, 0.54);
        margin-right: 4px;
    }
</style>


